import React from "react";
import { useState } from "react";
import styles from "./Budget.module.scss";
import { dollars, wholeNumber } from "../services/Filters";

export type BudgetVariant = "default" | "hero";

interface BudgetProps {
  accountId: string;
  currentWeekAverage?: number | null;
  budget: number | null;
  previousBudget: number | null;
  updateBudget: (value: number) => void;
  saveBudget: (value?: string) => void;
  variant?: BudgetVariant;
}

const Budget: React.FC<BudgetProps> = (props) => {
  const variant = props.variant ?? "default";
  const [newBudget, setNewBudget] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  const initialBudgetValue = props.previousBudget
    ? props.previousBudget.toString()
    : "";
  const budgetValue = isEditing ? newBudget : initialBudgetValue;

  function submitBudget(event: React.FormEvent) {
    event.preventDefault();
    props.saveBudget(budgetValue);
  }

  function updateBudget(value: string) {
    setIsEditing(true);
    switch (true) {
      case value === "":
      case value === "-":
        setNewBudget(value);
        props.updateBudget(+initialBudgetValue);
        break;
      case value.substring(0, 1) === "-":
        setNewBudget(value.substring(1));
        props.updateBudget(+value.substring(1));
        break;
      default:
        setNewBudget(String(+value));
        props.updateBudget(+value);
    }
  }

  const averageDisplay = props.currentWeekAverage
    ? dollars(wholeNumber(props.currentWeekAverage), 0)
    : "$-";

  if (variant === "hero") {
    return (
      <div id="budget" className={`${styles.budget} ${styles.heroVariant}`}>
        <form className={styles.heroForm} onSubmit={submitBudget}>
          <label className={styles.heroInputWrap} htmlFor="update_budget">
            <span className={styles.heroDollar} aria-hidden="true">
              $
            </span>
            <input
              type="number"
              min="0"
              max="99"
              step="1"
              id="update_budget"
              autoComplete="off"
              placeholder="Budget input here"
              value={budgetValue}
              onChange={(event) => updateBudget(event.target.value)}
              aria-label="$"
            />
          </label>
          <button type="submit" className={styles.heroSubmit}>
            SET MY BUDGET
          </button>
        </form>
        <p className={styles.heroNote}>
          You can change or remove your budget at any time.
        </p>
      </div>
    );
  }

  return (
    <div id="budget" className={styles.budget}>
      <div className={styles.content}>
        <div className={styles.itemFull}>
          <span>
            {
              "Set your weekly budget below and track against it week-to-week via the Tracker email. Your average weekly spend over the last "
            }
            <b>4 weeks</b>
            {" has been "}
            <b>{averageDisplay}</b>
          </span>
        </div>
        <div className={styles.itemFull} style={{ marginTop: "1rem" }}>
          <form onSubmit={submitBudget}>
            <div>
              <label htmlFor="update_budget">
                <span>$</span>
                <input
                  type="number"
                  min="0"
                  max="99"
                  step="1"
                  id="update_budget"
                  autoComplete="off"
                  value={budgetValue}
                  onChange={(event) => updateBudget(event.target.value)}
                />
              </label>
            </div>
            <div>
              <button type="submit">UPDATE BUDGET</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Budget;
